import { render, staticRenderFns } from "./Dialog_DiscountClassHour.vue?vue&type=template&id=54ec9c58&scoped=true&"
import script from "./Dialog_DiscountClassHour.vue?vue&type=script&lang=js&"
export * from "./Dialog_DiscountClassHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec9c58",
  null
  
)

export default component.exports